// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import OrderActionSet, {
    orderActionSetFieldDefinitions,
} from "@store/Library/Components/Toolkit/Order/OrderActionSet";
import { useHomePageUrl } from "@toolkit/Framework/Store/Links/LinksHooks";
import React from "react";

const enum fields {
    showPrint = "showPrint",
    showContinueShopping = "showContinueShopping",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.showPrint]: boolean;
        [fields.showContinueShopping]: boolean;
    };
}

type Props = OwnProps;

export interface RequisitionConfirmationActionsStyles {
    printButton?: ButtonPresentationProps;
    printLink?: LinkPresentationProps;
    continueButton?: ButtonPresentationProps;
    continueLink?: LinkPresentationProps;
}

export const requisitionConfirmationActionsStyles: RequisitionConfirmationActionsStyles = {};

const styles = requisitionConfirmationActionsStyles;

const RequisitionConfirmationActions = ({ fields: widgetFields }: Props) => {
    const history = useHistory();
    const homePageUrl = useHomePageUrl();

    const continueClickHandler = () => {
        history.push(homePageUrl);
    };

    return (
        <OrderActionSet
            fields={widgetFields}
            actions={[
                {
                    preset: "print",
                    linkStyles: styles.printLink,
                    buttonStyles: styles.printButton,
                    field: fields.showPrint,
                    testSelector: "printBtn",
                },
                {
                    key: "continue",
                    label: translate("Continue Shopping"),
                    onClick: continueClickHandler,
                    buttonStyles: styles.continueButton,
                    linkStyles: styles.continueLink,
                    isSticky: true,
                    testSelector: "continueBtn",
                    field: fields.showContinueShopping,
                },
            ]}
        />
    );
};

const widgetModule: WidgetModule = {
    component: RequisitionConfirmationActions,
    definition: {
        allowedContexts: ["RequisitionConfirmationPage"],
        group: "Requisitions",
        displayName: "Actions",
        fieldDefinitions: orderActionSetFieldDefinitions([
            { name: fields.showPrint },
            { name: fields.showContinueShopping },
        ]),
    },
};

export default widgetModule;
